import { useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Button, Select, SelectProps, Space } from 'antd';
import { DefaultOptionType } from 'antd/es/select';

import { useUserAuth } from '../../auth';
import { ConditionalWrapper } from '../../conditional-wrapper';
import { usePicker } from '../../picker';

import { useWorkerQuery } from './query-graph';

export const WorkerPicker = ({ excludeSelf, status, value, ...props }: SelectProps & { excludeSelf?: boolean }) => {
  const { search, getSelectProps } = usePicker();
  const { data, isFetching, isPending } = useWorkerQuery(search);
  const { user } = useUserAuth();
  const multiple = props?.mode === 'multiple';

  useEffect(() => {
    if (multiple !== Array.isArray(value))
      console.error('WorkerPicker: Data type of value does not match the selection mode.');
  }, [multiple, value]);

  const options = data
    ?.filter((x) => !!x.jobTitle && (!excludeSelf || x.jobTitle !== user?.enterpriseId))
    .map((x) => ({ value: x.jobTitle, label: x.displayName }));

  const handleAssignToMeClick = () => {
    const me = options?.find((x) => x.value === user?.enterpriseId);

    if (me) {
      if (multiple) {
        if (!value.find((x: DefaultOptionType) => x.value === user?.enterpriseId)) {
          props?.onChange && props.onChange([...value, me], me);
        }
      } else {
        props?.onChange && props.onChange(me, me);
      }
    }
  };

  return (
    <ConditionalWrapper
      condition={!excludeSelf}
      wrapper={(children) => (
        <Space>
          {children}
          <Button icon={<UserOutlined />} onClick={handleAssignToMeClick}>
            {multiple ? 'Add Me' : 'Assign to Me'}
          </Button>
        </Space>
      )}
    >
      <Select
        {...getSelectProps({
          ...props,
          loading: isFetching || isPending,
          status: props['aria-invalid'] ? 'error' : status,
        })}
        options={options}
        value={value}
      />
    </ConditionalWrapper>
  );
};
